module.exports = "/images/arror-right.svg?ff40e485ad4e72820e3b268d72e7ae4c";